import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { PATH, makeGiftStepsPath } from 'config'
import { selectors as memberSelectors } from 'member-reducer'
import { BOAT_USE_TYPE, MEMBERSHIP_TYPE, ProductPrices } from 'types'
import { MembershipTypeForm } from 'member-portal/forms'
import { ProductPricesUnavailable } from 'member-portal/components'
import * as actions from '../actions'

const propTypes = {
  membershipPrices: ProductPrices.isRequired,
  setSelectedMembershipType: PropTypes.func.isRequired,
}

function ProductSelection({ membershipPrices, setSelectedMembershipType }) {
  const history = useHistory()

  // Block if either giftable card price is missing instead of showing "N/A".
  const giftableTypes = [MEMBERSHIP_TYPE.GOLD_CARD, MEMBERSHIP_TYPE.LAKE_CARD]
  if (giftableTypes.some((type) => membershipPrices[type] == null)) {
    return <ProductPricesUnavailable />
  }

  return (
    <section className="form-block-container">
      <header className="header-title">
        <h1>Sea Tow Member Gift Options</h1>
      </header>
      <div className="card card-medium">
        <div className="card-inner">
          <div className="form-block">
            <MembershipTypeForm
              headingText="What membership would you like to gift?"
              initialValues={{
                selectedMembershipType: MEMBERSHIP_TYPE.GOLD_CARD,
              }}
              membershipPrices={membershipPrices}
              onSubmit={({ selectedMembershipType }) =>
                setSelectedMembershipType(selectedMembershipType)
              }
              onSubmitSuccess={() =>
                history.push(makeGiftStepsPath(PATH.RECIPIENT))
              }
              selectedUseTypes={[BOAT_USE_TYPE.RECREATIONAL]}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

ProductSelection.propTypes = propTypes

function mapStateToProps(state) {
  return {
    membershipPrices: memberSelectors.membershipPrices(state),
  }
}

const mapDispatchToProps = {
  setSelectedMembershipType: actions.setSelectedMembershipType,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  ProductSelection
)
